angular.module('cian.districtBrowser').directive('districtBrowser', () => {
  return {
    scope: {},
    bindToController: {
      selectedRegions: '=',
      geo: '=',
      newMoscow: '=',
    },
    template: require('../../templates/district-browser.html'),
    restrict: 'EA',
    controller: [
      '$element',
      '$uibModal',
      'RegionUtilsService',
      'FilterBackup',
      'AnalyticsService',
      function ($element, $uibModal, RegionUtilsService, FilterBackup, AnalyticsService) {
      this.isPopupOpen = false;

      angular.element($element[0].querySelector('.s-button')).on('click', () => {
        if (!this.isPopupOpen) {
          this.isPopupOpen = true;

          FilterBackup.backup();
          AnalyticsService.trackCA('Listing', 'popup_district_open');

          const isMoscowRegion = RegionUtilsService.isMoscowOrMO(this.selectedRegions);
          $uibModal.open({
            animation: true,
            windowClass: `serp-modal ${isMoscowRegion ? 'serp-modal_with_header' : ''} district-browser-popup`,
            template: require('../../templates/district-browser.popup.html'),
            controller: 'DistrictBrowserCtrl',
            controllerAs: 'modal',
            resolve: {
              regionWithDistricts: () => this.selectedRegions.find(r => r.hasDistricts),
              geo: () => this.geo,
              newMoscow: () => this.newMoscow,
            }
          }).result
            .then(null, FilterBackup.restore)
            .finally(() => this.isPopupOpen = false);
        }
      });
    }],
    controllerAs: 'districtBrowser'
  };
});



// WEBPACK FOOTER //
// ./src/components/district-browser/src/scripts/cian.district-browser.dir.js